import React from "react";

export default function TextSemibold({ children }) {
  return <p className="text-semibold">{children}</p>;
}
